import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import moment from "moment";

import { useStructuredSearchStore } from "@/components/StructuredSearch";
import { isSelectedEndTimeBeforeNow } from "@/components/StructuredSearch/utils/isSelectedEndTimeBeforeNow";

export const useStructuredSearchRefresh = () => {
  const queryClient = useQueryClient();
  const structuredSearchStore = useStructuredSearchStore();

  const clearNewDataBadge = useCallback(
    (queryKey: unknown[], data: Record<string, number>) => {
      queryClient.setQueriesData(queryKey, data);
    },
    [queryClient],
  );

  const advanceStructuredEndIfNeeded = useCallback((): boolean => {
    const now = moment().toDate();
    if (!isSelectedEndTimeBeforeNow(structuredSearchStore.dateRange.to, now)) {
      return false;
    }
    structuredSearchStore.setDateRange({
      from: structuredSearchStore.dateRange.from,
      to: now,
    });
    return true;
  }, [structuredSearchStore]);

  return { clearNewDataBadge, advanceStructuredEndIfNeeded };
};
